import React from "react";
import BottomBorder from "../../../components/BottomBorder";
import DateLabel from "../../../components/DateLabel";
import Header from "../../../components/Header";
import HTMLContent from "../../../components/HTMLContent";
import ImgContainer from "../../../components/ImgContainer";

import ArticleHeaderContainer from "../ArticleHeaderContainer";
import ArticleContainer from "../ArticleContainer";

function ArticleCard({
  hasShadow,
  hasBorder,
  hasRelativePosition,
  data: { title, slug, date, alt, caption, cover = {}, html },
  children: attachments,
}) {
  const header = <Header type="major" title={title} isHover={false} />;

  const articleHeader = date ? (
    <ArticleHeaderContainer>
      <div
        style={{
          maxWidth: "fit-content",
        }}
        className="pb-3 md:pb-5 w-auto max-w-fit"
      >
        {header}
      </div>
      {date && <DateLabel isLarge hasFullOpts date={date} />}
    </ArticleHeaderContainer>
  ) : (
    header
  );

  const articleBody = (
    <ImgContainer
      type="article"
      image={cover}
      alt={alt}
      caption={caption}
      slug={slug}
    >
      <HTMLContent html={html} />
    </ImgContainer>
  );

  return (
    <ArticleContainer
      isPreview={false}
      hasShadow={hasShadow}
      hasRelativePosition={hasRelativePosition}
      isFlexCol
      Component="article"
    >
      <div className="px-3 md:px-20">
        {articleHeader}
        {hasBorder ? (
          <BottomBorder className="border-opacity-25">
            {articleBody}
          </BottomBorder>
        ) : (
          <div>{articleBody}</div>
        )}

        {attachments}
      </div>
    </ArticleContainer>
  );
}

export default ArticleCard;
